import React from 'react';

export const Main: React.FC = props => {
  return <main className="o-main">{props.children}</main>;
};
